export default "__VITE_ASSET__DzFuIv2G__ 584w";